export default __webpack_public_path__ + "static/media/800.89a1af5a.woff";